/** Search aliases apply only to presentation, never execution entitlements. */
export type SkillEmployeeSearchIdentity = {
  name: string;
  nickname?: string | null;
  role?: string;
  roleKey?: string;
  department?: string;
};

/** Canonicalize presentation names without changing IDs or permissions. */
export function normalizeSkillEmployeeSearch(value: string): string {
  return value.normalize('NFKD').toLowerCase().replace(/\$/g, 's').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
}

export function matchesSkillEmployee(employee: SkillEmployeeSearchIdentity, query: string): boolean {
  const needle = normalizeSkillEmployeeSearch(query);
  if (!needle) return true;
  const words = [
    employee.name,
    employee.nickname,
    employee.role,
    employee.department,

  ];
  return words.some(value => { if (!value) return false; const normalized=normalizeSkillEmployeeSearch(String(value)); return normalized.includes(needle) || normalized.replace(/ /g, '').includes(needle.replace(/ /g, '')); });
}
